import * as React from 'react'
import { PageBody } from '../../routes/PageBody'
import { Grid, Typography } from '@alice-financial/pretext-ui'
import { ShiftSurvey } from './ShiftSurvey'
import { useOrg } from '../organization/useOrg'
import { ShiftsInstructions } from '../onboarding/steps/shifts'

export const ShiftSchedulingPage = () => {
  const org = useOrg()
  if (!org) return null
  return (
    <PageBody maxWidth="lg">
      <Typography variant="h1" gutterBottom>
        Shift scheduling
      </Typography>

      <Grid container spacing={2} flexDirection="row-reverse">
        <Grid size={{ xs: 12, md: 4 }}>
          <Typography variant="h4" color="text.secondary" gutterBottom>
            Instructions
          </Typography>

          <ShiftsInstructions />
        </Grid>
        <Grid size={{ xs: 12, md: 8 }}>
          <ShiftSurvey org={org} />
        </Grid>
      </Grid>
    </PageBody>
  )
}
